import { forwardRef, memo, useRef } from "react"

import BetPlacedChip from "../../../../../../library/Chips/BetChip"
import Chips from "../../../../../../library/Chips/Chips"

import Amar from "../../../../../../assets/games/AmarAkbarAntony/Amar.png"
import Akbar from "../../../../../../assets/games/AmarAkbarAntony/Akbar.png"
import Anthony from "../../../../../../assets/games/AmarAkbarAntony/Anthony.png"
import clear_img from "../../../../../../assets/games/AmarAkbarAntony/Clear.png"
import bet_img from "../../../../../../assets/games/AmarAkbarAntony/Bet_1.png"
import { convertBetValue } from "../../../../Utillitys/changeAmountToFixed"

const AmarAkbarAntonyBoard = forwardRef((props, ref) => {

    const aaa_chips = useRef(props.aaa_chipValues.split(",").map(ele => Number(ele)))
    const minFontSize = useRef(100)

    const getCardWinnerImage = () => {
        const rank = props.winner;

        if (rank === "Amar") return Amar;
        if (rank === "Akbar") return Akbar;
        if (rank === "Anthony") return Anthony;

        return ""; // fallback
    }

    return <div id="AAA_game_board">
        <div id="AAA_game_table">
            <div id="Amar_Akbar_Antony">
                <div id="Amar" className={`d-flex v_align chkBox${props.winner === "Amar" ? " AAA_winner" : ""}`}>
                    <div className="AAA_image_title">
                        <img className="AAA_images" src={Amar} alt="" onClick={() => { props.clickOnBet("Amar") }} />
                        <div className="imageName" onClick={() => { props.clickOnBet("Amar") }} >Amar</div>
                    </div>
                    <div className="cardNumbersDiv" onClick={() => { props.clickOnBet("Amar") }} >
                        <span className="cardNumbers">A</span>
                        <span className="cardNumbers">2</span>
                        <span className="cardNumbers">3</span>
                        <span className="cardNumbers">4</span>
                        <span className="cardNumbers">5</span>
                        <span className="cardNumbers">6</span>
                    </div>
                    <div className="AAA_bet_placed_Chip" onClick={() => { props.clickOnBet("Amar") }} >
                        {Boolean(props.betObj.Amar) && <BetPlacedChip minFontSize={minFontSize.current} gameId={props.gameId} chipString={props.aaa_chipValues} betAmount={props.betObj.Amar} chipWidth={"90%"} chipHeight={"90%"}></BetPlacedChip>}
                    </div>
                </div>
                <div id="Akbar" className={`d-flex v_align chkBox${props.winner === "Akbar" ? " AAA_winner" : ""}`}>
                    <div className="AAA_image_title">
                        <img className="AAA_images" src={Akbar} alt="" onClick={() => { props.clickOnBet("Akbar") }} />
                        <div className="imageName" onClick={() => { props.clickOnBet("Akbar") }} >Akbar</div>
                    </div>
                    <div className="cardNumbersDiv" onClick={() => { props.clickOnBet("Akbar") }} >
                        <span className="cardNumbers">7</span>
                        <span className="cardNumbers">8</span>
                        <span className="cardNumbers">9</span>
                        <span className="cardNumbers">10</span>
                    </div>
                    <div className="AAA_bet_placed_Chip" onClick={() => { props.clickOnBet("Akbar") }} >
                        {Boolean(props.betObj.Akbar) && <BetPlacedChip minFontSize={minFontSize.current} gameId={props.gameId} chipString={props.aaa_chipValues} betAmount={props.betObj.Akbar} chipWidth={"90%"} chipHeight={"90%"}></BetPlacedChip>}
                    </div>
                </div>
                <div id="Anthony" className={`d-flex v_align chkBox${props.winner === "Anthony" ? " AAA_winner" : ""}`}>
                    <div className="AAA_image_title">
                        <img className="AAA_images" src={Anthony} alt="" onClick={() => { props.clickOnBet("Anthony") }} />
                        <div className="imageName" onClick={() => { props.clickOnBet("Anthony") }} >Anthony</div>
                    </div>
                    <div className="cardNumbersDiv" onClick={() => { props.clickOnBet("Anthony") }} >
                        <span className="cardNumbers">J</span>
                        <span className="cardNumbers">Q</span>
                        <span className="cardNumbers">K</span>
                    </div>
                    <div className="AAA_bet_placed_Chip" onClick={() => { props.clickOnBet("Anthony") }} >
                        {Boolean(props.betObj.Anthony) && <BetPlacedChip minFontSize={minFontSize.current} gameId={props.gameId} chipString={props.aaa_chipValues} betAmount={props.betObj.Anthony} chipWidth={"90%"} chipHeight={"90%"}></BetPlacedChip>}
                    </div>
                </div>
            </div>
            <div className="AAA_button_Chip_controller">
                <div className="AAA_buttonController">
                    <div className="AAA_button_grp">
                        <div className="AAA_button_img_grp">
                            <img className="btn_images" src={clear_img} alt="" aria-disabled={props.isBetFreezed || !props.betAmount || props.betBtn === props.language.TAKE} onClick={() => { (!props.isBetFreezed && props.betAmount && props.betBtn === props.language.BetOK) && props.buttonClicked(props.language.Clear) }} />
                            <div className="AAA_btn_div" onClick={() => { !(props.isBetFreezed || !props.betAmount || props.betBtn === props.language.TAKE) && props.buttonClicked(props.language.Clear) }}><button className="AAA_buttons clear_btn" disabled={props.isBetFreezed || !props.betAmount || props.betBtn === props.language.TAKE}>{props.language.Clear}</button></div>
                        </div>
                        <div className="AAA_button_img_grp AAA_totalBet">
                            <div className="AAA_totalBet_div">
                                <img className="btn_images" src={bet_img} alt="" />
                                <div className="totalBetAmount">{convertBetValue(props.betAmount)}</div>
                            </div>
                            <button className="AAA_buttons totalBet_btn">{props.language.TotalBet}</button>
                        </div>
                    </div>
                    <div className="AAA_button_grp">
                        <div className="AAA_btn_div" role="button" onClick={() => { !(props.isBetFreezed || !props.betAmount || props.isDoubleDisabled || props.betBtn === props.language.TAKE) && props.buttonClicked(props.language.Double) }}><button className="AAA_buttons double_btn" disabled={props.isBetFreezed || !props.betAmount || props.isDoubleDisabled || props.betBtn === props.language.TAKE}>{props.language.Double}</button></div>
                        <div className="AAA_btn_div" role="button" onClick={() => { !(props.isBetFreezed || (props.betBtn === props.language.BetOK && !props.betAmount)) && props.buttonClicked(props.betBtn) }}><button className={`AAA_buttons bet_btn${props.betBtn === props.language.BetOK ? " betOkBtnActive" : ""}`} disabled={props.isBetFreezed || (props.betBtn === props.language.BetOK && !props.betAmount)} >{props.betBtn}</button></div>
                    </div>
                </div>
                <div className="AAA_chipsCointainer">
                    <div className="aaa_chip_selector_box" onClick={(e) => {
                        if (props.selectedChip.index >= 1) {
                            props?.playTheSound("pokerChipSound");
                            props.setSelectedChip((prevState) => ({ ...prevState, value: Number(aaa_chips.current[prevState.index - 1]), index: prevState.index - 1 }));
                        }
                    }}>
                        <button className="chipArrows" disabled={props.selectedChip.index === 0 || props.isBetFreezed} >
                        </button>
                    </div>
                    <div className="aaa_chipsBox">
                        <div className="aaa_chips" style={{ "--selectedIndex": props.selectedChip.index, "--totalChips": props.aaa_chipValues.split(",").length }}>
                            <Chips
                                selectedChipIndex={props.selectedChip.index}
                                chipSelectionFn={(value, index) => {
                                    window.innerHeight > window.innerWidth && props?.playTheSound("pokerChipSound");;
                                    !props.isBetFreezed && props.setSelectedChip({ value, index });
                                }}
                                gameChips={props.aaa_chipValues}
                                chipWidth="100%" chipHeight="100%"
                            />
                        </div>
                    </div>
                    <div className="aaa_chip_selector_box" onClick={() => {
                        if (props.selectedChip.index < aaa_chips.current.length - 1) {
                            props?.playTheSound("pokerChipSound");
                            props.setSelectedChip((prevState) => ({ ...prevState, value: Number(aaa_chips.current[prevState.index + 1]), index: prevState.index + 1 }));
                        }
                    }}>
                        <button className="chipArrows rightArrow" disabled={props.selectedChip.index === aaa_chips.current.length - 1 || props.isBetFreezed}>
                        </button>
                    </div>
                </div>
            </div>
        </div>
        {props.showWinAmount && <div class="AAA_modal">
            <div class="AAA_modal__content">
                <div class="AAA_modal__header">
                    {/* <span class="modal__close-button modal__button red" onClick={() => { props.setShowWinAmount(false) }}>&times;</span> */}
                    <h1 class="AAA_modal__title">{props.language.WINNER}</h1>
                </div>
                <div class="AAA_modal__body">
                    <img src={getCardWinnerImage()} id="AAA_winner_image" alt="Descriptive Text" class="AAA_modal__image" />
                    <h4 class="AAA_modal__text-score-label">{props.language.YOU_WON}</h4>
                    <h1 class="AAA_modal__text-score">{props.winAmount}</h1>
                </div>
            </div>
        </div>}
    </div >
})

export default memo(AmarAkbarAntonyBoard)